import React, { Component } from 'react';
import { cloneDeep } from 'lodash';
import { Form, Input, Modal } from 'antd';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class MessageForm extends Component {
    constructor() {
        super();

        this.state = {};

        this.formRef = React.createRef();
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
            this.props.onSubmit(values);
        });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();
    }

    handleDidMount = (data = {}) => {
        const cloneData = cloneDeep(data);
        this.formRef.current.setFieldsValue(cloneData);
        this.setState({ editMode: !!cloneData.id });
    }

    render() {
        const { onCancel, submitting, visible } = this.props;
        const { editMode } = this.state;

        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={748}>
                <Form ref={this.formRef} layout="vertical">
                    <Form.Item name="title" label={Resources.title} rules={Rules.required}>
                        <Input type="text" />
                    </Form.Item>
                    <Form.Item name="body" label={Resources.text} rules={Rules.required}>
                        <Input.TextArea rows={6} />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
};

export default MessageForm;